
seedWebApp.controller('UserSettingsV2Controller', ['$scope', 'UserSettingService', '$uibModal', 'ToastService', 'TranslationService', function ($scope, UserSettingService, $uibModal, ToastService, TranslationService) {

    $scope.prefs = {
        name: 'UserSettingGrid',
        sortByCol: null,
        canAdd: false,
        canEdit: true,
        canDelete: false,
    };

    $scope.customClass = function (item) {
        if (item == 'NORMAL')
            return 'set-label normal-user';
        else if (item == 'AGENT')
            return 'set-label agent-user';
    };

    $scope.isInactiveClass = function (item) {
        if (item == 'Ativo')
            return 'sd-active-user';
        else if (item == 'Inativo')
            return 'sd-inactive-user';
    };

    $scope.columns = [
        { name: 'UserID', display: $scope.translation.User, orderBy: 'asc', filterOptions: [], editable: false, width: 15, isKey: true },
        { name: 'Email', display: $scope.translation.Email, filterOptions: [], editable: true, width: 15 },
        { name: 'UserName', display: $scope.translation.UserName, filterOptions: [], editable: true, width: 10 },
        { name: 'UserType', display: $scope.translation.UserType, customClass: $scope.customClass, filterOptions: [], editable: true, width: 5 },
        { name: 'UserRoleName', id: 'UserRoleID', display: $scope.translation.UserRoleName, filterOptions: [], editable: true, width: 15 },
        { name: 'UserRole', display: 'ROLE', filterOptions: [], editable: true, width: 10 },
        { name: 'AccessTime', display: $scope.translation.AccessTime, filterOptions: [], dataType: 'date', isUTC: true, format: 'dd/MM/yy HH:mm', editable: true, width: 5 },

        //{ name: 'ContactName', id: 'ContactID', display: $scope.translation.ContactName, filterOptions: [], editable: true, width: 30 },

        { name: 'ContactName', id: 'ContactID', display: 'Cliente', editable: true, width: 30 },
        { name: 'ContactCount', display: 'Nr Clientes', editable: true, width: 30 },

        { name: 'Invited', display: 'Convidado', filterOptions: [], editable: true, width: 10, dataType: 'boolean' },
        { name: 'IsInactive_Display', display: $scope.translation.Inactive, filterOptions: [], editable: true, width: 5, customClass: $scope.isInactiveClass },
    ];

    $scope.inviteUser = function () {

        var user = {
            UserID: '',
            UserType: 'NORMAL',
            UserContacts: []
        };

        var modalInstance = $uibModal.open({
            templateUrl: '/SPA/Settings/Users/UserSettingDetails.html' + seedWebApp.buildVersion,
            controller: 'UserSettingDetailsController',
            size: 'lg',
            resolve: {
                user: function () {
                    return user;
                },
                createMode: function () {
                    return true;
                },
                canChangePassword: function () {
                    return false;
                }
            }
        });
        modalInstance.result.then(function () {
            $scope.doRefresh();
        });
    };

    $scope.prefs.customEdit = function (user) {
        //console.warn('loggedUser', $scope.loggedUser);
        var canChangePassword = $scope.loggedUser.UserRoleID == 'Admin';
        var modalInstance = $uibModal.open({
            templateUrl: '/SPA/Settings/Users/UserSettingDetails.html' + seedWebApp.buildVersion,
            controller: 'UserSettingDetailsController',
            size: 'lg',
            resolve: {
                user: function () {
                    return user;
                },
                createMode: function () {
                    return false;
                },
                canChangePassword: function () {
                    return canChangePassword;
                    //return $scope.UserID.includes('@seed.com.br');
                }
            }
        });
    };

    $scope.prefs.removeItem = function (item) {};
    $scope.prefs.saveItem = function (item) {};

    $scope.loadColumns = UserSettingService.getUsersColumns;
    $scope.loadService = UserSettingService.getUsers;
    $scope.resetService = UserSettingService.resetCache;

    $scope.getTotal = function () {
        $scope.loadingTotal = true;
        UserSettingService.getUsersCount().then(function (response) {
            $scope.loadingTotal = false;
            $scope.totalItems = response.data;
        });
    };

    $scope.getTotal();

    $scope.searchMode = function () {
        $scope.$broadcast('inputSearch', $scope.filterString);
    };

    $scope.doRefresh = function () {
        $scope.$broadcast('refreshServiceGrid');
    };

    $scope.toExcel = function () {
        $scope.$broadcast('toExcel', 'Usuarios');
    };

    $scope.doInsert = function () {
        $scope.$broadcast('addItem');
    };

    //$(document).ready(function () {
    //    $scope.overflowSize = $scope.AdjustSize();
    //});

}]);
